window.addEventListener('load', function () {
    if (document.querySelectorAll('.headerImage').length) {
        gsap.registerPlugin(ScrollTrigger);
        let element = document.querySelector('.headerImage');
        let decorative = element.querySelector('.decorative');

        ScrollTrigger.matchMedia({
            '(min-width: 1400px)': function () {
                /* parallax scroll */
                gsap.to(decorative, {
                    yPercent: -100,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: element,
                        start: '50% 30%',
                        end: '+200% 30%',
                        scrub: true,
                        //markers: true
                    },
                });
            },
        });
    }
});
